import { EmoticonHappyIcon } from './EmoticonHappyIcon';

/**
 * author: Michael Irigoyen
 * id CCA0187D-B8BA-4AC3-8523-B6B8F05EA5BA
 * name emoticon-happy
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-happy.svg
 * tags
 * - Emoji 
 */
export const FaceHappyIcon = EmoticonHappyIcon;
export default FaceHappyIcon